export const subscriptionTypes = {
  FREE: 'FREE',
  PAID: 'PAID',
};
